import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';
import { Checkbox } from '../../components/Checkbox/Checkbox';
import { setSeparateStay } from '../../redux/currentSearch/actions';
import { getSeparateStay, shouldShowSeparateStay } from '../../redux/currentSearch/selectors';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { TrackingUtils } from '../../utils';

export const SeparateStayCheckbox = ({ separateStay, setSeparateStay, trackEvent, shouldShowSeparateStay }) => {
    const onSeparateStayChange = () => {
        const enabled = !separateStay.enabled;
        const action = TrackingUtils.ACTION.DP;
        const label = TrackingUtils.LABEL.separateStay({ enabled });
        trackEvent({ action, label });
        setSeparateStay({
            ...separateStay,
            enabled,
        });
    };

    const checkboxProps = {
        id: 'separate-stay-switcher',
        checked: separateStay.enabled,
        onChange: onSeparateStayChange,
        disabled: !shouldShowSeparateStay,
    };
    return (
        <React.Fragment>
            { shouldShowSeparateStay && (
                <div className="odf-space-inner-bottom-s">
                    <Checkbox {...checkboxProps}>
                        <CMS id='flightsManager.accommodation.checkInDates' />
                    </Checkbox>
                </div>
            )}
        </React.Fragment>
    );
};

SeparateStayCheckbox.propTypes = {
    setSeparateStay: PropTypes.func.isRequired,
    separateStay: PropTypes.shape({
        enabled: PropTypes.bool,
        checkInDate: PropTypes.instanceOf(Date),
        checkOutDate: PropTypes.instanceOf(Date),
    }),
    shouldShowSeparateStay: PropTypes.bool.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

SeparateStayCheckbox.defaultProps = {
    separateStay: {
        enabled: false,
    },
};

const mapStateToPropsSelector = createStructuredSelector({
    separateStay: getSeparateStay,
    shouldShowSeparateStay: shouldShowSeparateStay,
});

export const ConnectedSeparateStayCheckbox = connect(mapStateToPropsSelector, {
    setSeparateStay,
})(withPageContext(SeparateStayCheckbox));
